import {Directive, ViewContainerRef, TemplateRef, AfterViewInit, Input, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from '@angular/common';

@Directive({selector: '[renderInView]'})
export class InViewDirective implements AfterViewInit {
  @Input() public renderInView = true;
  private alreadyRendered = false;

  constructor( @Inject(PLATFORM_ID) protected platformId: Object,
               private vcRef: ViewContainerRef,
               private tplRef: TemplateRef<any> ) {}

  public ngAfterViewInit() {
    const commentEl = this.vcRef.element.nativeElement;
    const elToObserve = commentEl.parentElement;
    if (!this.renderInView || isPlatformServer(this.platformId)) {
      this.renderContents(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach((entry) => {
        this.renderContents(entry.isIntersecting)
      });
    }, {threshold: [0, .1, .9, 1]});
    observer.observe(elToObserve);
  }

  private renderContents(isInView) {
    if (isInView && !this.alreadyRendered) {
      this.vcRef.clear();
      this.vcRef.createEmbeddedView(this.tplRef);
      this.alreadyRendered = true;
    }
  }
}
